import { createSlice } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
// utils
import axios from "../../utils/axios";
import { PATH_DASHBOARD } from "../../routes/paths";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  update: false,
  seasons: [],
  fetchLoading: false,
  singleSeason: null,
};

const slice = createSlice({
  name: "season",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // START LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },
    // UPDATE EVENT
    updateSeasonSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.seasons = state.seasons.map((season) => {
        if (season.id === action.payload.id) {
          return action.payload;
        }
        return season;
      });
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.update = false;
      state.error = action.payload;
    },

    // GET PRODUCTS
    getSeasonSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.seasons = action.payload;
    },

    // GET SINGLE SUCCESS
    getSingleSeasonSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.singleSeason = action.payload;
    },

    // GET PRODUCTS
    createSeasonSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.seasons = [...state.seasons, action.payload];
    },

    // DELETE EVENT
    deleteSeasonSuccess(state, action) {
      const seasonId = action.payload;
      state.seasons = state.seasons.filter((season) => season.id !== seasonId);
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
});

export default slice.reducer;

export function getSeasons() {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get("seasons");
      dispatch(slice.actions.getSeasonSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSingleSeason({ id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`seasons/${id}`);
      dispatch(slice.actions.getSingleSeasonSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createSeasons({ data, enqueueSnackbar, navigate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post("seasons", data);
      dispatch(slice.actions.createSeasonSuccess(response.data.data));
      enqueueSnackbar("Season is added successfully");
      navigate(-1);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateSeasons({ id, data, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`seasons/${id}`, data);
      dispatch(slice.actions.updateSeasonSuccess(response.data.data));
      enqueueSnackbar("Season is updated successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteSeason({ id, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`seasons/${id}`);
      dispatch(slice.actions.deleteSeasonSuccess(id));
      enqueueSnackbar("Season is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
